<script setup>
const props = defineProps({
    active: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <div
        :class="[
            'relative rounded-lg shadow-md border bg-white dark:bg-gray-800 transition-all overflow-hidden',
            'flex flex-col gap-4 p-4 md:p-6',
            props.active ? 'border-l-4 border-blue/30' : 'border-l-4 border-white dark:border-gray-800'
        ]"
    >
        <!-- Header Slot -->
        <div v-if="$slots.header" class="mb-4">
            <slot name="header" />
        </div>

        <!-- Default Slot -->
        <div class="flex-1">
            <slot />
        </div>

        <!-- Action Slot -->
        <div v-if="$slots.action" class="mt-4">
            <slot name="action" />
        </div>
    </div>
</template>
